(() => {
  const prepareLinks = () => {
    const theme = window.Shopify?.theme;
    document.querySelectorAll('a[data-hf-faq-link]').forEach((link) => {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      if (url.origin !== window.location.origin) return;
      if (theme && ['unpublished', 'development', 'demo'].includes(theme.role)) {
        url.searchParams.set('preview_theme_id', String(theme.id));
      } else {
        url.searchParams.delete('preview_theme_id');
      }
      link.href = url.pathname + url.search + url.hash;
    });
  };

  const mediaTargets = {
    '#hf-groessenguide': '57252628267346',
    '#hf-leuchteffekt-video': '56921090556242',
  };
  let generation = 0;
  const jumpToMedia = async () => {
    const mediaId = mediaTargets[window.location.hash];
    const run = ++generation;
    if (!mediaId) return;
    const section = document.querySelector('[id$="__hf_product"]');
    const gallery = section?.querySelector('media-gallery');
    const slideshow = gallery?.querySelector('slideshow-component');
    const media = slideshow?.querySelector(`[data-media-id="${mediaId}"]`);
    const slide = media?.closest('slideshow-slide');
    if (!gallery || !slideshow || !slide) return;
    await customElements.whenDefined('slideshow-component');
    if (document.readyState !== 'complete') {
      await new Promise((resolve) => window.addEventListener('load', resolve, { once: true }));
    }
    await document.fonts.ready;
    const image = media.querySelector('img');
    if (image) image.loading = 'eager';
    const scrollGallery = () => {
      const headerBottom = Math.max(0, ...Array.from(document.querySelectorAll('#header-group, header-component'), (header) => header.getBoundingClientRect().bottom));
      const galleryTop = gallery.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: Math.max(0, galleryTop - headerBottom - 16), behavior: 'instant' });
    };
    scrollGallery();
    await new Promise(requestAnimationFrame);
    await new Promise(requestAnimationFrame);
    const aligned = () => {
      const scroller = slideshow.querySelector('[ref="scroller"]');
      if (!scroller) return false;
      const frame = scroller.getBoundingClientRect();
      const target = slide.getBoundingClientRect();
      return Math.abs(target.left - frame.left) < 3 && target.width > 0;
    };
    for (let attempt = 0; attempt < 80; attempt++) {
      if (run !== generation || mediaTargets[window.location.hash] !== mediaId) return;
      const index = slideshow.slides?.indexOf(slide);
      if (index >= 0) {
        await slideshow.select(index, undefined, { animate: false });
        await new Promise(requestAnimationFrame);
        await new Promise(requestAnimationFrame);
        if (slideshow.current === index && aligned()) {
          if (image && !image.complete) {
            await Promise.race([image.decode().catch(() => {}), new Promise((resolve) => setTimeout(resolve, 2000))]);
          }
          await new Promise((resolve) => setTimeout(resolve, 180));
          if (run !== generation) return;
          if (slideshow.current === index && aligned()) {
            scrollGallery();
            // Let scroll restoration and late layout shifts settle. Any customer
            // interaction immediately ends this short, initial alignment pass.
            const controller = new AbortController();
            const cancel = () => controller.abort();
            ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((type) => {
              window.addEventListener(type, cancel, { once: true, passive: true, signal: controller.signal });
            });
            try {
              for (let settle = 0; settle < 10; settle++) {
                await new Promise((resolve) => setTimeout(resolve, 100));
                if (controller.signal.aborted || run !== generation) return;
                scrollGallery();
              }
            } finally {
              controller.abort();
            }
            return;
          }
        }
      }
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
  };

  prepareLinks();
  if (document.readyState === 'complete') jumpToMedia();
  window.addEventListener('hashchange', jumpToMedia);
  window.addEventListener('pageshow', () => {
    prepareLinks();
    requestAnimationFrame(() => requestAnimationFrame(jumpToMedia));
  });
})();
